
import React, { Component } from "react";
import { translate } from "react-polyglot";
import queryString from 'query-string';

import Modal from "../Modal";
import List from '../List';
import Pill from '../Pill';
import Button from '../Button';
import Rating from '../Rating';
import LoaderBlock from '../LoaderBlock';
import CenterModeCarousal from "../CenterModeCarousal";
import OfflineTranslateSurveyForm from "../OfflineTranslateSurveyForm";

import { starRatingQuestions } from '../../lib/constants';
import translationEN from '../../i18n/en.json';


import './NextTranslationModal.scss';

class NextTranslationModal extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      selectedRating: -1,
      selectedReasons: [],
      isNextTranslationVisible: false,
      showOfflineTranslateSurveyForm: false
    };
  }

  onSelect = (type) => {
    if(this.state.selectedReasons.includes(type)) {
      this.setState({ selectedReasons: this.state.selectedReasons.filter(item => item !== type) })
    }
    else {
      this.setState({ selectedReasons: [...this.state.selectedReasons, type] })
    }
  }

  onSubmit = () => {
    this.setState({ isNextTranslationVisible: true })
    let selectedReasons = this.state.selectedReasons.map(r => {
      return {reason: translationEN[`StarRatingModal.rating-${starRatingQuestions[this.state.selectedRating].name}-${r}`], query_reason: r}
    });
    this.props.postTranslationEditorFeedbackWorkflow(selectedReasons, this.state.selectedRating+1)
  }

  onSelectRating = (ratings) => {
    this.setState({ selectedRating: ratings, selectedReasons: [] })
  }

  componentDidMount() {
    const queryParams = queryString.parse(window.location.search);
    if (queryParams.type === 'offline') {
      this.setState({showOfflineTranslateSurveyForm: true})
    }
  }

  render () {
  const {
    t,
    onCloseClicked,
    nextTranslationBooks,
    viewport,
    nextSuggestionsType,
    translateToLanguage,
    translationEditorFeedbackPresent,
    isSubmittingTranslationEditorFeedback,
    isFetchingMe,
    userId,
    offlineTranslationEditorFeedbackPresent,
    postOfflineTranslationFeedbackWorkflow,
    addSlimNotification,
    isSubmittingOfflineTranslationFeedback } = this.props;

    const baseClassName = 'pb-next-translate-modal';
    let questionsEl = null;

    if(isFetchingMe) {
      return (
        <Modal parentClassName={`${baseClassName}__rating-modal`} >
          <LoaderBlock />
        </Modal>
      )
    }

    if(this.state.selectedRating >= 0) {
      let selectedRatingQuestions = starRatingQuestions[this.state.selectedRating]
      questionsEl = <div className={`${baseClassName}__questions-wrapper`}>
                      <div className={`${baseClassName}__rating-name`}>{t(`StarRatingModal.rating-${selectedRatingQuestions.name}`)}</div>  
                      <List parentClassName={`${baseClassName}__questions`}>
                        {
                          selectedRatingQuestions.questions.map(q => {
                            return <Pill 
                                     key={q} 
                                     label={t(`StarRatingModal.rating-${selectedRatingQuestions.name}-${q}`)}
                                     onClick={this.onSelect.bind(this, q)}
                                     isSelected={this.state.selectedReasons.includes(q)}/>
                          })
                        }
                      </List>
                    </div>
    }

    const submitEl = (
      <div className={`${baseClassName}__submit-wrapper`}>
        <Button 
        parentClassName={`${baseClassName}__submit`} 
        label={t('global.submit')} 
        variant="primary" 
        fullWidth
        long
        onClick={() => { this.onSubmit() }}
        disabled={this.state.selectedRating === -1}
        loading={isSubmittingTranslationEditorFeedback} />
      </div>
    );

    const header = <h2 className={`${baseClassName}__title`}>
                    {t(`StarRatingModal.title`)}
                  </h2>;

    return (
      !offlineTranslationEditorFeedbackPresent && this.state.showOfflineTranslateSurveyForm
        ?
        <OfflineTranslateSurveyForm
          postOfflineTranslationFeedbackWorkflow={postOfflineTranslationFeedbackWorkflow}
          addSlimNotification={addSlimNotification}
          isSubmittingOfflineTranslationFeedback={isSubmittingOfflineTranslationFeedback}
          onClose={() => this.setState({ showOfflineTranslateSurveyForm: false, isNextTranslationVisible: true })}
          isRtl={this.props.isRtl}
        />
        :
        this.state.isNextTranslationVisible || translationEditorFeedbackPresent
          ?
          <Modal
            onClose={onCloseClicked}
            narrow={viewport.xlarge}
            wide={viewport.large && !viewport.xlarge}
            extraWide={viewport.medium && !viewport.large}
            isRtl={this.props.isRtl}
          >
            <CenterModeCarousal
              onCloseClicked={onCloseClicked}
              books={nextTranslationBooks}
              nextSuggestionsType={nextSuggestionsType}
              translateToLanguage={translateToLanguage}
              viewport={viewport}
              userId={userId}
              isRtl={this.props.isRtl}
            />
          </Modal>
          :
          <Modal parentClassName={`${baseClassName}__rating-modal`} starRating extraLong={this.state.selectedReasons.length !== 0}>
            {header}
            <Rating parentClassName={`${baseClassName}__rating`} onSelect={this.onSelectRating} type="normal" />
            {questionsEl}
            {submitEl}
          </Modal>
    );
}};

export default translate()(NextTranslationModal);



// WEBPACK FOOTER //
// ./src/components/NextTranslationModal/NextTranslationModal.jsx